<!-- eslint-disable vue/no-mutating-props, vue/no-multiple-template-root, no-undef -->
<template>
  <div class="profile-dashboard">
    <!-- profile-edit-container-->
    <div class="profile-edit-container">
      <!-- statistic-container-->
      <div class="statistic-container fl-wrap">
        <!-- statistic-item-wrap-->
        <div class="statistic-item-wrap">
          <div class="statistic-item gradient-bg fl-wrap">
            <i class="fas fa-regular fa-map-marker" />
            <div class="statistic-item-numder">
              {{ activeListingsCount }} / {{ adLimit }}
            </div>
            <h5>Active Listings</h5>
            {{ Math.max(0, adLimit - activeListingsCount) }} listings remaining
          </div>
        </div>
        <!-- statistic-item-wrap end-->
        <!-- statistic-item-wrap-->
        <div class="statistic-item-wrap">
          <div class="statistic-item gradient-bg fl-wrap">
            <i class="fas fa-regular fas fa-regular fa-eye" />
            <div class="statistic-item-numder">
              {{ totalListingViews }}
            </div>
            <h5>Listing Views</h5>
            <small>total views on all your listings</small>
          </div>
        </div>
        <!-- statistic-item-wrap end-->
        <!-- statistic-item-wrap-->
        <div class="statistic-item-wrap">
          <div class="statistic-item gradient-bg fl-wrap">
            <i class="fas fa-regular fa-comments" />
            <div class="statistic-item-numder">
              --
            </div>
            <h5>Total Reviews</h5>
            <small>currently unavailable</small>
          </div>
        </div>
        <!-- statistic-item-wrap end-->
      </div>
      <!-- statistic-container end-->
    </div>
    <!-- profile-edit-container end-->
    <!-- dashboard-list Start-->
    <div class="profile-edit-container add-list-container">
      <div class="profile-edit-header fl-wrap">
        <h4>Recently Viewed Listings</h4>
      </div>
      <div class="custom-form">
        <div
          v-if="historyLoading"
          style="text-align:center; padding: 20px;"
        >
          <i
            class="fas fa-spinner fa-spin"
            style="font-size: 24px; color: #a45362;"
          />
        </div>
        <div
          v-else-if="recentlyViewed.length === 0"
          style="text-align:center; padding: 20px; color: #888;"
        >
          You haven't viewed any listings recently.
        </div>
        <div
          v-else
          class="history-list"
          style="margin-top: 15px;"
        >
          <div 
            v-for="item in recentlyViewed" 
            :key="item.listingId"
            class="history-item"
            style="display: flex; align-items: center; justify-content: space-between; border-bottom: 1px solid #eee; padding: 15px 0;"
          >
            <!-- Left: Image and info -->
            <div style="display: flex; align-items: center; gap: 15px;">
              <div 
                style="width: 80px; height: 80px; border-radius: 8px; background-size: cover; background-position: center; flex-shrink: 0;"
                :style="{ backgroundImage: `url(${item.coverImage || '/images/all/1.jpg'})`, opacity: item.status !== 'active' ? '0.5' : '1' }"
              />
              <div>
                <h5
                  style="margin: 0; font-size: 16px; color: #333;"
                  :style="{ opacity: item.status !== 'active' ? '0.5' : '1' }"
                >
                  {{ item.title }}
                </h5>
                <span style="font-size: 13px; color: #888;">{{ item.category }}</span>
                <div
                  v-if="item.status !== 'active'"
                  style="color: #d9534f; font-size: 12px; font-weight: bold; margin-top: 4px;"
                >
                  This listing is no longer available
                </div>
              </div>
            </div>
            
            <!-- Right: Price & Button -->
            <div style="text-align: right;">
              <div
                style="font-weight: bold; font-size: 18px; color: #a45362; margin-bottom: 5px;"
                :style="{ opacity: item.status !== 'active' ? '0.5' : '1' }"
              >
                {{ item.currency }}{{ item.price }}
              </div>
              <router-link 
                v-if="item.status === 'active'"
                :to="{ name: 'pet-details', params: { id: item.listingId } }" 
                class="btn color-bg" 
                style="padding: 6px 15px; font-size: 12px;"
              >
                View Again
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- recommendations Start -->
    <div
      v-if="recommendations.length > 0"
      class="profile-edit-container add-list-container"
    >
      <div class="profile-edit-header fl-wrap">
        <h4>Recommended for You</h4>
      </div>
      <div class="custom-form">
        <div
          class="history-list"
          style="margin-top: 15px;"
        >
          <div 
            v-for="item in recommendations" 
            :key="item.listingId"
            class="history-item"
            style="display: flex; align-items: center; justify-content: space-between; border-bottom: 1px solid #eee; padding: 15px 0;"
          >
            <!-- Left: Image and info -->
            <div style="display: flex; align-items: center; gap: 15px;">
              <div 
                style="width: 80px; height: 80px; border-radius: 8px; background-size: cover; background-position: center; flex-shrink: 0;"
                :style="{ backgroundImage: `url(${item.coverImage || '/images/all/1.jpg'})` }"
              />
              <div>
                <h5 style="margin: 0; font-size: 16px; color: #333;">
                  {{ item.title }}
                </h5>
                <span style="font-size: 13px; color: #888;">{{ item.category }}</span>
              </div>
            </div>
            
            <!-- Right: Price & Button -->
            <div style="text-align: right;">
              <div style="font-weight: bold; font-size: 18px; color: #a45362; margin-bottom: 5px;">
                {{ item.currency }}{{ item.price }}
              </div>
              <router-link 
                :to="{ name: 'pet-details', params: { id: item.listingId } }" 
                class="btn color-bg" 
                style="padding: 6px 15px; font-size: 12px;"
              >
                View
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- recommendations end -->
  </div>
</template>

<script setup>
import { defineProps, ref, onMounted } from 'vue';
import { useViewTracker } from '@/composables/useViewTracker';

const recentlyViewed = ref([]);
const recommendations = ref([]);
const historyLoading = ref(true);

onMounted(async () => {
  const { getHistory, getRecommendations } = useViewTracker();
  try {
    recentlyViewed.value = await getHistory();
    recommendations.value = await getRecommendations();
  } catch (err) {
    console.error(err);
  } finally {
    historyLoading.value = false;
  }
});
defineProps({
  activeListingsCount: {
    type: Number,
    required: true
  },
  adLimit: {
    type: Number,
    required: true
  },
  totalListingViews: {
    type: Number,
    default: 0
  }
});
</script>


